type AudienceOptions = {
	country?: { [key: string]: string };
	department?: { [key: string]: string };
	employment_type?: { [key: string]: string };
	location?: { [key: string]: string };
	role?: { [key: string]: string };
};

export enum CatalogState {
	Active = 'active',
	Paused = 'paused',
	Shutoff = 'shutoff',
}

type ChatIntegrations = {
	has_slack_integration: boolean;
	has_ms_teams_integration: boolean;
};

export enum ProductTier {
	TierFree = 'tier_free', // free plan
	TierOne = 'tier_one', // appreciate
	TierTwo = 'tier_two', // connect
	TierThree = 'tier_three', // Organization plan
	TierAlpha = 'tier_alpha', // Team plan
}

export enum UserMode {
	Benefactor = 'benefactor',
	Bot = 'bot',
	Normal = 'normal',
	Observer = 'observer',
	Receiver = 'receiver',
}

export enum PromotedRewardsSetting {
	BonuslyPromoted = 'bonusly_promoted',
	CompanyPromoted = 'company_promoted',
	Disabled = 'disabled',
}
export interface Company {
	id: string;
	audience_options: AudienceOptions;
	axomo_subdomain?: string;
	bonus_privacy: boolean;
	budget: {
		id: string;
		display_unit: string;
		exchange_rate: number;
		format: {
			singular: string;
			plural: string;
		};
		has_custom_currency: true;
		iso_code: string;
		plural: string;
		singular: string;
	};
	catalog_state: CatalogState;
	created_at: string;
	company_hashtags: string[];
	core_values: Array<{ hashtag: string; description: string }>;
	disable_gifs: boolean;
	disable_image_uploads: boolean;
	disable_video_recordings: boolean;
	disable_video_uploads: boolean;
	example_reason: string;
	has_celebrations: boolean;
	has_active_benefactors: boolean;
	has_claimable_awards: boolean;
	hashtagging_mode: string;
	hide_competitive_features: boolean;
	/**
	 * Limited release mode for One-on-Ones features. When true, allows specific users
	 * to pilot One-on-Ones features via user-level flags while keeping it disabled
	 * company-wide. Set to false when ready to roll out One-on-Ones to the entire organization.
	 */
	limited_release_mode: boolean;
	locale: string;
	logo_url: string;
	monarch_cohort: string;
	name: string;
	next_billing_at: string;
	product_tier: ProductTier;
	product_plan_name: string;
	promoted_rewards_setting: PromotedRewardsSetting;
	sign_up_company_size: number;
	status: string;
	subscription_days_past_due: number;
	trial_end_date: string;
	trial_start_date: string;
	updated_at: string;
	user_management_integration_url: string;
	zero_point_bonuses: boolean;
	is_demo: boolean;
	is_superadmin_initialized: boolean;
	has_sample_data: boolean;
	show_bonus_amounts: boolean;
	chat_integrations: ChatIntegrations;
	active_user_count?: number;
	free_tier_user_limit?: number;
	check_in_settings?: {
		mandatory: boolean;
		effective_date?: string;
	};
	/**
	 * Whether rewards billing is enabled for this company.
	 * When false, users can only redeem no-cost rewards (Points Boost, Exclusives, Swag).
	 * When true or undefined (for backwards compatibility), all rewards are available.
	 */
	rewards_billing_enabled?: boolean;
}
